import BrokersApi from '../BrokersApi';
import * as types from './ActionTypes';
import IBrokerTreeNode from '../IBrokerTreeNode';
import IBrokerChain from '../chain/IBrokerChain';

function newBrokerChainSuccess(result: any) {
    return { type: types.NEW_BROKER_CHAIN_SUCCESS, result };
}

export function newBrokerChain() {
    return (dispatch: (result: any) => void) =>
        BrokersApi.newBrokerChain().then((result: any) => {
            dispatch(newBrokerChainSuccess(result));
        });
}

function createBrokerChainSuccess(result: IBrokerTreeNode) {
    return { type: types.CREATE_BROKER_CHAIN_SUCCESS, result };
}

export function createBrokerChain(data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.createBrokerChain(data).then((result: IBrokerTreeNode) => {
            dispatch(createBrokerChainSuccess(result));
        });
}

function editBrokerChainSuccess(result: IBrokerChain) {
    return { type: types.EDIT_BROKER_CHAIN_SUCCESS, result };
}

export function editBrokerChain(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.editBrokerChain(id).then((result: IBrokerChain) => {
            dispatch(editBrokerChainSuccess(result));
        });
}

function updateBrokerChainSuccess(result: IBrokerChain) {
    return { type: types.UPDATE_BROKER_CHAIN_SUCCESS, result };
}

export function updateBrokerChain(id: number, data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.updateBrokerChain(id, data).then((result: IBrokerChain) => {
            dispatch(updateBrokerChainSuccess(result));
        });
}
